// extracted by mini-css-extract-plugin
module.exports = {"list":"post-feed-module--list--37gyZ","listItem":"post-feed-module--list-item--1-o5r"};